import { Button, Col, Form, FormInstance, Row, Select } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';

import { Feature } from '../../../shared/models/features';
import { translationNamespace } from '../../constants/translation-resources';
import { RangePicker } from '../../../shared/components/date-picker/date-picker';

enum PresetsTableFilter {
  NAME = 'name',
  DEFINITION_NAME = 'definitionName',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}

export interface PresetsTableFilters {
  [PresetsTableFilter.NAME]: string[];
  [PresetsTableFilter.DEFINITION_NAME]: string[];
  [PresetsTableFilter.CREATED_AT]: [Date?, Date?];
  [PresetsTableFilter.UPDATED_AT]: [Date?, Date?];
}

interface PresetsTableFiltersFormProps {
  onApply?: (filters: PresetsTableFilters) => void;
  form: FormInstance<PresetsTableFilters>;
}

export const PresetsTableFiltersForm: FC<PresetsTableFiltersFormProps> = ({ onApply, form }) => {
  const { t } = useTranslation(translationNamespace);

  const onClear = () => {
    form.resetFields();
    onApply?.(form.getFieldsValue());
  };

  return (
    <Form form={form} layout="vertical" onFinish={onApply}>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label={t(`${Feature.SHARED}:name`)} name={PresetsTableFilter.NAME}>
            <Select suffixIcon={null} size="large" mode="tags" allowClear open={false} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label={t(`${Feature.SHARED}:definition.label`)} name={PresetsTableFilter.DEFINITION_NAME}>
            <Select suffixIcon={null} size="large" mode="tags" allowClear open={false} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label={t(`${Feature.SHARED}:createdAt`)} name={PresetsTableFilter.CREATED_AT}>
            <RangePicker css={fullWidthStyles} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label={t(`${Feature.SHARED}:updatedAt`)} name={PresetsTableFilter.UPDATED_AT}>
            <RangePicker css={fullWidthStyles} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col>
          <Button type="primary" htmlType="submit" size="large" icon={<CheckOutlined />}>
            {t(`${Feature.SHARED}:apply`)}
          </Button>
        </Col>
        <Col>
          <Button htmlType="button" size="large" onClick={onClear}>
            {t(`${Feature.SHARED}:clear`)}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const fullWidthStyles = css`
  width: 100%;
  border-radius: 0;
`;
